<template>
  <div class="Card flex animate-pulse items-center gap-3">
    <div class="OrgLogoWrapper shrink-0">
      <div class="OrganizationLogo !bg-gray-200" />
    </div>
    <div class="flex min-w-0 flex-1 flex-col gap-1.5">
      <div class="h-4 w-2/5 rounded bg-gray-200" />
      <div class="h-3 w-1/4 rounded bg-gray-200" />
    </div>
    <div class="h-8 w-24 shrink-0 rounded-lg bg-gray-200" />
  </div>
</template>
